import React from "react";
import { FiMinus } from "react-icons/fi";
import { MdOutlinePublishedWithChanges, MdUnpublished } from "react-icons/md";

export const ListingStatusIcon = ({ item, onClick }) => {
  const getStatusColor = () => {
    if (item?.is_blocked) return "black";
    if (item?.is_published) return "green";
    return "red";
  };

  const getStatusIcon = () => {
    if (item?.is_blocked) return <FiMinus />;
    if (item?.is_published) return <MdOutlinePublishedWithChanges />;
    return <MdUnpublished />;
  };

  return (
    <div
      className="position-absolute z-3 cursor-pointer"
      style={{
        top: "10px",
        left: "10px",
        backgroundColor: getStatusColor(),
        color: "white",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {getStatusIcon()}
    </div>
  );
};

